/* @ngInject */
const metadata = (
  contactFields
) => {
  const self = {}

  self.fields = contactFields

  return self
}

export default metadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/services/metadata.service.js